// @flow
import { createAction } from 'redux-actions';
import {
    OPEN, CLOSE_BY_KEY, CLOSE_TOPMOST, CLOSE_ALL, SET_SENSITIVITY, SET_TITLE,
} from './constants';

export const openPanel = createAction(
    OPEN, (
        key: string, title: ?string = '', url: ?string = null, sensitive: ?(boolean | { message: string }),
        continuity?: boolean, closeIfNotTopmost?: boolean, additionalProps?: Object,
    ) => ({
        key, title, url, sensitive, continuity, closeIfNotTopmost, additionalProps,
    }),
);

export const closePanel = createAction(
    CLOSE_BY_KEY, (key: string, skipSensitivity: boolean = false) => ({ key, skipSensitivity }),
);

export const closeTopmost = createAction(
    CLOSE_TOPMOST, (skipSensitivity: boolean = false) => ({ skipSensitivity }),
);

export const closeAllPanels = createAction(
    CLOSE_ALL, (skipSensitivity: boolean = false) => ({ skipSensitivity }),
);

export const setSensitivity = createAction(
    SET_SENSITIVITY, (key: string, sensitive: ?(boolean | { message: string })) => ({ key, sensitive }),
);

export const setTitle = createAction(
    SET_TITLE, (key: string, title: string) => ({ key, title }),
);
